import { SegmentedControl } from "@mantine/core";
import React from "react";
import { useState } from "react";
import ConnectionCompanies from "../companies/ConnectionCompanies";
import ConnectionJobSeeker from "../jobseeker/ConnectionJobSeeker";

const Connections = () => {
  const [value, setValue] = useState("companies");
  return (
    <div>
      <SegmentedControl
        mb={"md"}
        size="lg"
        value={value}
        color={"red.9"}
        onChange={setValue}
        data={[
          { label: "Companies", value: "companies" },
          { label: "Job Seekers", value: "jobSeekers" },
        ]}
      />

      {value === "jobSeekers" ? (
        <ConnectionJobSeeker />
      ) : (
        <ConnectionCompanies />
      )}
    </div>
  );
};

export default Connections;
